import * as React from 'react';

import { Columns } from 'components/columns';
import ColumnsItem, { ColumnsSize } from 'components/columns/columns-item';
import { CtaBox, CtaBoxHeader, CtaBoxText } from 'components/cta-box';
import GoodToKnow from 'components/good-to-know/good-to-know';
import PageSection from 'components/page/page-section';
import PageSectionCtaWithoutImage from 'components/page/sections/page-section-cta-without-image';
import Table from 'components/table/table';
import { Header3 } from 'components/typography';

import { getPropsSectionSixContainer } from './section-six-container.props';

export const SectionSixContainer: React.FC = () => {
  const props = getPropsSectionSixContainer();
  return (
    <>
      <PageSection color="transparent" extraClass="section-cta" padding="bottom" inner={true}>
        <CtaBox align="start">
          <CtaBoxHeader>{props.sections.one.text1}</CtaBoxHeader>
        </CtaBox>
        <Columns vAlignTop={true}>
          <ColumnsItem size={ColumnsSize['1/2']}>
            <CtaBox align="start">
              <CtaBoxHeader></CtaBoxHeader>
              <CtaBoxText>{props.sections.one.text2}</CtaBoxText>
            </CtaBox>
          </ColumnsItem>
          <ColumnsItem size={ColumnsSize['1/2']}>
            <CtaBox align="start">
              <CtaBoxHeader></CtaBoxHeader>
              <CtaBoxText>{props.sections.one.text3}</CtaBoxText>
            </CtaBox>
          </ColumnsItem>
        </Columns>
      </PageSection>
      <PageSectionCtaWithoutImage
        titleElement={props.sections.two.titleElement}
        text={
          <CtaBox align="start">
            <CtaBoxText>{props.sections.two.text}</CtaBoxText>
          </CtaBox>
        }
        imageText={
          <div className="is-hidden-when-print">
            <GoodToKnow
              title={props.sections.two.goodToKnow.title}
              contentHtml={props.sections.two.goodToKnow.text}
            />
          </div>
        }
        columnLeft={{ size: ColumnsSize['1/2'] }}
        columnRight={{ size: ColumnsSize['1/2'] }}
        color="peach"
      />
      <PageSection color="peach" extraClass="section-cta" padding="block" inner={true}>
        <Columns hasMobileLayout={true}>
          <ColumnsItem size={ColumnsSize['1/2']}>
            <div className="table-wrapper table-wrapper--no-overflow">
              <div className="is-shown-when-print">
                <GoodToKnow
                  title={props.sections.two.goodToKnow.title}
                  contentHtml={props.sections.two.goodToKnow.text}
                />
              </div>
              <Table
                rows={[
                  [
                    <div style={{ textAlign: 'center' }} key={props.sections.two.example.title}>
                      <Header3>{props.sections.two.example.title}</Header3>
                    </div>,
                  ],
                  [props.sections.two.example.content],
                ]}
                th={true}
              />
            </div>
          </ColumnsItem>
          <ColumnsItem size={ColumnsSize['1/2']}>
            <CtaBox align="start">
              <CtaBoxText>{props.sections.two.exampleRight.text}</CtaBoxText>
            </CtaBox>
          </ColumnsItem>
        </Columns>
      </PageSection>
      <PageSection color="transparent" extraClass="section-cta" padding="block" inner={true}>
        <Columns hasMobileLayout={true}>
          <ColumnsItem size={ColumnsSize.fluid}>
            <CtaBox align="start">
              <CtaBoxHeader tag="h2">{props.sections.three.titleElement}</CtaBoxHeader>
              <CtaBoxText>{props.sections.three.text}</CtaBoxText>
            </CtaBox>
          </ColumnsItem>
        </Columns>
      </PageSection>
    </>
  );
};
